import type { Search } from './search';

const CLASSIFICATION_LINK_TYPE = 'Classification';
const JOBTYPE_LINK_TYPE = 'JobType';
const KEYWORD_LINK_TYPE = 'Keyword';
const LOCATION_LINK_TYPE = 'Location';
const COMPANY_LINK_TYPE = 'Company';
const PARAMETERIZED_LINK_TYPE = 'Parameterized';

const createLinkType = (segments: Set<string>): string =>
  Array.from(segments)?.sort()?.join('-');

export const getSEOMarketingLinkType = (search: Search): string => {
  const segments = new Set<string>();

  const {
    advertiserid,
    classification,
    keywords,
    subclassification,
    where,
    worktype,
  } = search?.query || {};
  const { company: companySuggestion } = search?.result?.suggestions ?? {};

  if (keywords) {
    if (companySuggestion) {
      segments.add(COMPANY_LINK_TYPE);
    } else {
      segments.add(KEYWORD_LINK_TYPE);
    }
  }

  if (classification || subclassification) {
    segments.add(CLASSIFICATION_LINK_TYPE);
  }

  if (worktype) {
    segments.add(JOBTYPE_LINK_TYPE);
  }

  if (where) {
    segments.add(LOCATION_LINK_TYPE);
  }

  if (advertiserid) {
    segments.delete(KEYWORD_LINK_TYPE);
    segments.add(COMPANY_LINK_TYPE);
  }

  const seoMarketingLinkType =
    !segments.size && search?.hasQueryParams
      ? PARAMETERIZED_LINK_TYPE
      : createLinkType(segments);

  return seoMarketingLinkType;
};
